
function init_accordion(){
    var els = document.querySelectorAll('.accordion--title');
    els.forEach((el) => {
      el.addEventListener('click', e => {
        if (e.pointerType === "mouse") {} // mouse event
        else {} // touch event
        e.classList.toggle('is--active');
      
      });
      el.onclick = function() {
        el.classList.toggle('is--active');
      }
    });
  const items = document.querySelectorAll('table');
  for (let i = 0; i < items.length; i++) {
      const wrapper = document.createElement('div');
    wrapper.classList.add("table");
      items[i].parentNode.insertBefore(wrapper, items[i]);
      wrapper.appendChild(items[i]);
  }
}
if(document.readyState !== 'loading') {
  init_accordion();
}else{
  document.addEventListener('DOMContentLoaded', function() {
    init_accordion();   
  },false);
}